import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { OLD_SITE_URL } from "../constants/constants";

export const oldSiteServiceApi = createApi({
  reducerPath: "oldSiteApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: OLD_SITE_URL,
      prepareHeaders: async (headers) => {
        return headers;
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    // if (
    //   result.error &&
    //   result.error?.status === 401 &&
    //   (result?.error?.data as any)?.message === "Unauthorized"
    // ) {
    //   localStorage.removeItem(OLD_AUTH_LOCALSTORAGE_NAME);
    //   window.location.reload();
    // }

    return result;
  },

  keepUnusedDataFor: 0,
  endpoints: () => ({}),
});
